import React from "react";
import PropTypes from "prop-types";
import { DFPAdsHorizontal } from "../../dfp-ad-horizontal";
import { StoryCard } from "../story-card";
import "./story-card-stack.m.css";

export class StoryCardStack extends React.Component {
  storyCardStack = () => {
    const getStoryCards = this.props.story.cards.map((card, index) => {
      const flag = index !== 0 && index % 2 === 0;
      return (
        <React.Fragment key={card.id}>
          {flag && <DFPAdsHorizontal />}
          {<StoryCard index={index} key={card.id} card={card} story={this.props.story} />}
        </React.Fragment>
      );
    });
    return getStoryCards;
  };
  render() {
    return this.storyCardStack();
  }
}

StoryCardStack.propTypes = {
  story: PropTypes.object
};
